import React, { useCallback } from 'react'
import { getConfig } from '../../../../config'
import { InstallType } from '../../../../lib/hooks/install-eligibility'
import {
  BrowserSpecificExtensionInstallButtonBase,
  BrowserSpecificExtensionInstallButtonProps,
} from './browser-specific'

const { downloadUrl } = getConfig().products.extension.edgeChromium

export type EdgeInstallButtonProps = BrowserSpecificExtensionInstallButtonProps

export const EdgeChromiumInstallButton: React.FC<EdgeInstallButtonProps> = (props) => {
  const handleInstall = useCallback(() => {
    window.open(downloadUrl)
  }, [])

  return (
    <BrowserSpecificExtensionInstallButtonBase
      {...props}
      installUrl={downloadUrl}
      onClick={handleInstall}
      install={InstallType.EdgeChromium}
    />
  )
}
